/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import DevelopmentsService from '@/services/DevelopmentsService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`developments/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getDevelopmentsFilters = handler(
  'getDevelopmentsFilters',
  DevelopmentsService.getDevelopmentsFilters
);

export const getDevelopmentsList = handler(
  'getDevelopmentsList',
  DevelopmentsService.getDevelopmentsList
);

export const getCompanyIntegrationsStatus = handler(
  'getCompanyIntegrationsStatus',
  DevelopmentsService.getCompanyIntegrationsStatus
);
